<template>
  <div style="width: 100%;">
    <!-- <el-carousel indicator-position="outside"
                 style="width:100%"
                 arrow="never"
                 height="380px">
      <el-carousel-item v-for="x in 1"
                        :key="x+'x'"> -->
    <div style="margin-top:20px;width: 100%;">
      <!-- :style="{'backgroundImage':'url(' + item.url + ')' ,'backgroundPosition':'50%','backgroundSize':index != activeIndex?'cover':'100% 100%' ,'backgroundRepeat': 'no-repeat'}" -->
      <div class="witness_list">
        <!-- 左侧大屏 image.png-->
        <div class="left">
          <!-- :style="{'transform':activeIndex==-1?'scale(1.5)':''}" -->
          <img class="dong"
               :src="$imgUrl + 'aboutUs/QYWH_img.png'"
               alt="">
          <!-- <div class="active">客户见证——永辉超市：合伙人机制</div> -->
        </div>
        <div class="right">
          <div class="witness_item"
               v-for="(item,index) in list"
               :key="index"
               @mouseenter="mouseover(index)"
               @mouseleave="mouseout"
               :style="{'background-color':activeIndex == index?'#DE1F26':'#fff','color':activeIndex == index?'#fff':'#333333'}">
            <div class="font24"
                 style="margin-bottom:18px;">{{item.title}}</div>
            <div class="font18"
                 style="margin-bottom:6px"
                 v-for="(x,y) in item.content"
                 :key="y+'y'">
              {{x}}
            </div>
            <!-- <img class="dong"
                 :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                 :src="item.url"
                 alt=""> -->
            <!-- <div class="active">客户见证——永辉超市：合伙人机制</div> -->
          </div>
        </div>
        <!-- <div v-else
                 style="flex:1;"
                 class="right">
              <div class="witness_item_content">
                <img class="dong"
                     :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                     :src="item.url"
                     alt="">
                <div v-if="activeIndex!=index"
                     class="active"></div>
              </div>
            </div> -->
      </div>
    </div>
    <!-- </el-carousel-item>
    </el-carousel> -->
    <videoModal v-if="videoShow"
                ref="videoModal"
                @close="closeModal"></videoModal>
    <!-- <el-dialog custom-class="dialogClass"
               :visible.sync="centerDialogVisible"
               width="50%"
               center>
      <div>
        <video controls
               class="video"
               :autoplay="false"
               :src="videoUrl"></video>
      </div>

    </el-dialog> -->
  </div>
</template>
<script>
import videoModal from '@/components/video/videoModal.vue'
export default {

  components: { videoModal },
  data () {
    return {
      videoShow: false,
      videoUrl: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
      centerDialogVisible: false,
      activeIndex: -2,
      // list:[
      // 	{}
      // ]
      list: [
        { url: 'https://img0.baidu.com/it/u=2266992387,3653937162&fm=253&fmt=auto&app=138&f=JPEG?w=346&h=500', bg: 'linear-gradient(90deg, #1f8ffb, #0f54ec)', title: '务实', content: ['言行一致', '诚实守信', '敬业爱岗'] },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', bg: 'linear-gradient(90deg, #19CEAD, #00B292)', title: '创新', content: ['与时俱进', '引领当下', '勇于探索'] },
        { url: 'https://img2.baidu.com/it/u=2616025538,1484344267&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500', bg: 'linear-gradient(90deg, #FA6992, #EA2B61)', title: '分享', content: ['成人达己', '乐于奉献', '胸怀天下'] },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)', title: '合作', content: ['互利共赢', '和衷共济', '团结共创'] },
        // { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
      ]
    }
  },
  methods: {
    itemClick (index) {
      this.videoShow = true;
      this.$nextTick(() => {
        this.$refs.videoModal.init({ videoUrl: this.videoUrl })
      })
    },
    closeModal () {
      this.videoShow = false;
    },
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout () {
      this.activeIndex = -2
    }
  }
}
</script>
<style lang="less" scoped>
.dialogClass {
  padding: 0 !important;
}
.video {
  width: 100%;
  height: 100%;
}
.witness_list {
  width: 100%;
  display: flex;
  // height: 536px;
  .left {
    width: 384px;
    margin-right: 23px;
    // height: calc(100% - 20px);
    background-color: #fff;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dong {
    // width: 100%;
    // height: 100%;
    // transition: all 2s;
    z-index: 11;
  }
  // .dong:hover {
  //   transform: scale(1.2);
  //   cursor: pointer;
  // }
  .active {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    line-height: 56px;
    text-align: center;
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    font-size: 16px;
  }
  // witness_item
  .right {
    flex: 1;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .witness_item:nth-child(2) {
      margin-right: 0;
    }
    .witness_item:nth-child(3) {
      margin-bottom: 0;
    }
    .witness_item:nth-child(4) {
      margin-right: 0;
      margin-bottom: 0;
    }
    .witness_item {
      // display: inline-block;
      width: calc((100% - 23px) / 2);
      margin-right: 23px;
      height: 258px;
      margin-bottom: 20px;
      // padding: 20px;
      box-sizing: border-box;
      // background-color: #fff;
      transition: all 0.3s ease-in-out;
      position: relative;
      overflow: hidden;
      text-align: center;
      padding-top: 70px;
      // display: flex;
      // justify-items: center;
      // align-items: center;
      // .hide {
      //   width: 100%;
      //   height: 100%;
      //   padding: 50px;
      //   border-radius: 10px;
      //   box-sizing: border-box;
      //   background: rgba(0, 0, 0, 0.4);
      //   color: #fff;
      //   display: flex;
      //   align-items: center;
      //   text-align: center;
      //   justify-content: center;
      //   font-size: 30px;
      // }
      // .show {
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: rgba(255, 0, 0, 0.6);
      //   border-radius: 10px;
      //   padding: 30px;
      //   box-sizing: border-box;
      //   color: #fff;
      // }
    }
  }
}
</style>